import { Injectable } from '@angular/core';
import { Canvas, FabricObject, StaticCanvas } from 'fabric';
import { MnemonicInterface } from '../../_interfaces/mnemonic.interface';

export type MnemonicCanvasInstance = Canvas | StaticCanvas;

@Injectable({
    providedIn: 'root',
})
export class MnemonicCanvasLifecycleService {
    createCanvas(elementId: string, isEditable: boolean): MnemonicCanvasInstance {
        FabricObject.prototype.objectCaching = false;

        if (isEditable) {
            return new Canvas(elementId, {
                containerClass: 'mnemonic-canvas',
                backgroundImage: null,
                selection: true,
                preserveObjectStacking: true,
                fireRightClick: true,
                fireMiddleClick: true,
                stopContextMenu: true,
                selectionFullyContained: true,
            });
        }

        return new StaticCanvas(elementId, {
            containerClass: 'mnemonic-canvas',
            backgroundImage: null,
            selection: false,
            preserveObjectStacking: true,
            fireRightClick: true,
            fireMiddleClick: true,
            stopContextMenu: true,
            selectionFullyContained: true,
        });
    }

    resize(canvas: MnemonicCanvasInstance, options: { withSidebar: boolean }): void {
        const mnemonicElement = document.querySelector('.mnemonic') as HTMLElement | null;

        if (!mnemonicElement) {
            return;
        }

        if (options.withSidebar) {
            canvas.setDimensions({
                width: mnemonicElement.clientWidth - 310,
                height: mnemonicElement.clientHeight - 9,
            });
        } else {
            canvas.setDimensions({
                width: mnemonicElement.clientWidth - 15,
                height: mnemonicElement.clientHeight - 15,
            });
        }

        canvas.renderAll();
    }

    dispose(canvas: MnemonicCanvasInstance | null | undefined): void {
        canvas?.dispose();
    }

    resolveObjectById(canvas: MnemonicCanvasInstance, id?: string): FabricObject | null {
        if (!id) {
            return null;
        }

        return (canvas.getObjects().find((object: any) => object.id === id) as FabricObject) ?? null;
    }

    isOwner(mnemonic: MnemonicInterface | null | undefined, userId: string | undefined): boolean {
        return !!mnemonic && !!userId && mnemonic.userId === userId;
    }
}
